<template>
  <div>
    <!-- <tableHealthKit :dataSteps="dataTable" @closeModal="showTable = false" :dateTilte="dateTest" :isShow="showTable" /> -->
    <stepCountChart :userId="userId" @close="closeModalStepChart" v-if="showTableStepChart" :time_out_facility="this.time_out_facility" :isExpand="isExpand"/>
    <div class="card mb-0" style="min-height: 50vh !important" v-else>
      <Loader :loading="loader">
        <div class="d-flex justify-content-between mb-2">
          <b-button :disabled="activeExport()" :class="{'bg-disabled': activeExport()}"
                      class="btn-lyg float-end w-lg mt-lg-n2" @click="doAction()"
                      style="padding: 5px; font-size: 14px;">
              Excel出力
            </b-button>
          <h5 class="card-title mb-3"></h5>
          <div>
            <b-button class="btn-lyg w-lg mt-lg-n2" style="margin-right: 10px; padding: 5px; font-size: 14px; border-radius: 4px; box-shadow: none" @click="openModalStepChart">歩数グラフ</b-button>
          </div>
        </div>

        <div class="col-12">
          <b-table :items="gHealthKit || []" :fields="fields" hover outlined thead-class=" text-center bg-table-lyg"
            sticky-header responsive="sm" :style="{maxHeight: isExpand ? '66vh': '48vh'}">
            <template #head(eventDate)>
              <div @click="onSort('event_date')">
                <span>チェック日</span>
                <i class="mdi mdi-sort-bool-ascending" v-if="typeSort == 0"></i>
                <i class="mdi mdi-sort-bool-descending" v-else></i>
              </div>
            </template>

            <template #head(#)>
              <b-form-checkbox id="checkbox-all" @change="checkAll()" name="checkbox-all" :checked="isCheckedAll()">
              </b-form-checkbox>
            </template>

            <template #cell(#)="row">
              <b-form-checkbox id="checkbox-1" @change="chooseItem(row.item.id)" name="checkbox-1"
                :checked="isChecked(row.item.id)">
              </b-form-checkbox>
            </template>

            <template #cell(patientId)="row">
              {{ row.item ? row.item.user.patient_id : "" }}
            </template>

            <template #cell(fullName)="row">
              {{ row.item ? row.item.user.name : "" }}
            </template>

            <template #cell(compareYesterday)="row">
              <div class="d-flex">
                <span class="d-flex justify-content-end w-50 mx-1">
                  {{ row.item.step_diff ? Math.abs(row.item.step_diff) : 0 }}歩
                </span>
                <span class="flex-start">
                  <i class="bx bx-up-arrow-alt mb-0" style="color: #8fc31f; font-size: 24px" v-if="row.item.diff > 0"></i>
                  <i class="bx bx-down-arrow-alt mb-0" style="color: red; font-size: 24px" v-if="row.item.diff < 0"></i>
                </span>
              </div>
            </template>

            <template #cell(eventDate)="row">
              {{ row.item.event_date | formatDateLocal }}
            </template>

            <!-- <template #cell(dataTable)="row">
              <ul class="list-inline font-size-18 contact-links mb-0">
                <li class="list-inline-item px-2" @click="(showTable = true), (dataTable = row.item.steps)">
                  <a v-b-tooltip.hover v-b-modal.modal-xl title="詳細">
                    <i class="bx bx-bar-chart-alt-2 text-white bg-info p-1" style="border-radius: 50%; cursor: pointer"></i>
                  </a>
                </li>
              </ul>
            </template> -->
          </b-table>
        </div>
        <div class="d-flex justify-content-center text-center mt-5" v-if="gHealthKit.length === 0">
          <div class="undefine">
            <img src="@/assets/images/no-data.jpg" alt="" />
            <div class="mt-3">詳細データはありません。</div>
          </div>
        </div>

      </Loader>
    </div>
    <Pagination :paging="pagination" @change="OnPagination" :theme="theme" label="件数:" unitLabel="件" v-if="!showTableStepChart"/>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { filter } from "../../helpers/Vue-Filter";
import { healthKitMethod, healthKitComputed } from "@/state/helpers";
import Loader from "./loader.vue";
import { mixin } from "../../helpers/Vue-Mixin";
import tableHealthKit from "./tableHealthKit.vue";
import stepCountChart from "./stepCountChart.vue";
import api from "@/api/";
import {sumBy} from 'lodash';
import Pagination from "./pagination.vue";
import moment from "moment";
export default {

  filters: {
    ...filter,
  },

  mixins: [mixin],

  props: {
    userId: {
      type: Number,
      required: true,
    },
    time_out_facility: {
      type: String,
      required: false
    },
    userInfor: {
      require: true
    },
    isExpand: {
      type: Boolean,
    }
  },
  components: { Loader, tableHealthKit, stepCountChart,Pagination },

  data() {
    return {
      items: [
        {
          text: "歩数グラフ",
          href: "/admin/health-kit",
          active: true,
        },
      ],

      filter: {},
      filterOn: [],
      sortBy: "age",
      sortDesc: false,

      dataInsert: {},
      dataUpdate: {},
      pagination: {
        current_page: 1,
        total: 20,
        per_page: 20,
      },
      loader: false,
      valueSelectStatus: null,
      valueSelectSex: null,
      page: 1,
      paginationPages: 5,
      isFlagShowModalAdd: false,
      isFlagShowModalEdit: false,

      showTable: false,
      dateTest: null,

      dataTable: [],

      keySort: "event_date",
      typeSort: 0,
      types: ["desc", "asc"],

      isAll: false,
      ignoreIds: [],
      excelIds: [],
      showTableStepChart: false,
    };
  },


  async created() {
    try {
      this.loader = true;
      this.getACountHealthKit();
      await this.fetchHealthKit({
        user_id: this.userId,
        key_sort: this.keySort,
        type_sort: this.types[this.typeSort],
        time_out_facility: this.time_out_facility,
      }).then((e) => {
        if (e.status === 200) {
          this.loader = false;
        }
      });

      this.pagination = Object.assign(this.gPaginationHealthKit, {});

    } catch (error) {
      console.error(error);
    }
  },

  watch: {
    gPaginationHealthKit: {
      handler(value) {
        this.pagination = Object.assign(value, {});
        this.paginationPages = value.last_page;
      },
      deep: true,
    },
  },

  computed: {
    ...healthKitComputed,
    theme() {
      return this.$store.state.theme;
    },
    fields() {
      return [
        { key: "#", class: "text-center align-middle p-3 tilte-column" },
        {
          key: "eventDate",
          label: "チェック日",
          class: "text-center align-middle p-3 tilte-column",
        },
        {
          key: "steps",
          label: "歩数",
          class: "text-center align-middle p-3 tilte-column",
          formatter: (val) => (val && val.length) ? Math.round(sumBy(val, 'value')) : 0,
        },
        {
          key: "distance",
          label: "距離（m）",
          class: "text-center align-middle p-3 tilte-column",
          formatter: (val) => (val && val.value) ? Math.round(val.value) : 0
        },
        {
          key: "calories",
          label: "キロカロリー(kcal)",
          class: "text-center align-middle p-3 tilte-column",
          formatter: (val) => (val && val.length) ? Math.round(sumBy(val, 'value')) : 0,
        },
        {
          key: "compareYesterday",
          label: "前日との比較（歩数）",
          class: "text-center align-middle p-3 tilte-column",
        },
        // {
        //   key: "dataTable",
        //   label: "歩数グラフ（1日）",
        //   class: "text-center align-middle p-3 tilte-column",
        // },
      ];
    },
  },

  methods: {
    ...healthKitMethod,

    async onFilter() {
      this.getACountHealthKit();
      await this.handlerSearch();
    },

    async handlerSearch(page = 1) {
      try {
        this.loader = true;
        this.page = page < 1 ? 1 : page;
        const payloadSearch = Object.assign(
          {
            user_id: this.userId,
            page: this.page,
            key_sort: this.keySort,
            type_sort: this.types[this.typeSort],
            time_out_facility: this.time_out_facility,
          },
          this.filter
        );
        await this.fetchHealthKit(payloadSearch).then((e) => {
          if (e.status === 200) {
            this.loader = false;
          }
        });
      } catch (error) {
        console.log(error);
      }
    },

    async handlerSubmit() {
      try {
        await this.post(this.dataInsert);
      } catch (error) {
        console.log(error);
      }
    },

    onSort(key) {
      if (key === this.keySort) {
        this.typeSort = Math.abs(this.typeSort - 1);
      } else {
        this.keySort = key;
        this.typeSort = 0;
      }

      this.handlerSearch();
    },

    async OnPagination(page) {
      try {
        this.loader = true;
        await this.handlerSearch(page);
      } catch (error) {
        console.log(error);
      }
    },

    closeModal() { },

    closeModalStepChart(){
      this.showTableStepChart = false;
    },

    openModalStepChart(){
      this.showTableStepChart = true;
    },

    showAdd() { },

    async handlerReject() {
      try {
        Swal.fire({
          title: "Are you sure?",
          text: "Do you want to reject?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, reject it!",
        }).then(async (result) => {
          if (result.isConfirmed) {
            const respon = await this.reject();
            if (respon.status === 200) {
              this.alertSuccess();
              this.fetchHospital();
            }
            if (respon.status !== 200) {
              this.alertError(respon.status);
              return;
            }
          }
        });
      } catch (error) {
        console.log(error);
      }
    },

    showModalEdit() { },

    chooseItem(id) {
      if (this.isAll) {
        this.ignoreIds = this.setArray(this.ignoreIds, id);
        if (this.ignoreIds.length === this.gPaginationHealthKit.total) {
          this.isAll = false;
          this.ignoreIds = [];
        }
      } else {
        this.excelIds = this.setArray(this.excelIds, id);
        if (this.excelIds.length === this.gPaginationHealthKit.total) {
          this.isAll = true;
          this.excelIds = [];
        }
      }
    },

    setArray(array, id) {
      const index = array ? array.findIndex((element) => element === id) : -1;
      index >= 0 ? array.splice(index, 1) : array.push(id);

      return array;
    },
    isChecked(id) {
      return (
        (this.isAll && !this.ignoreIds.includes(id)) ||
        this.excelIds.includes(id)
      );
    },

    isCheckedAll() {
      if (this.gHealthKit.length > 0) {
        return (
          (this.isAll && this.ignoreIds.length === 0) ||
          this.excelIds.length === this.gPaginationHealthKit.total
        );
      }

      return false;
    },

    checkAll() {
      if (this.ignoreIds.length > 0) {
        this.ignoreIds = [];
      } else {
        this.isAll = !this.isAll;
        if (!this.isAll) {
          this.excelIds = [];
        }
      }
    },

    activeExport() {
      if (this.gHealthKit.length > 0) {
        return !this.isAll && this.excelIds.length === 0;
      }

      return true;
    },

    async doAction() {
      if (!this.isAll && this.excelIds.length === 0) {
        window.toastr.error("歩数グラフを選択してください");
      } else {
        try {
          let payload = {
            user_id: this.userId,
            key_sort: this.keySort,
            type_sort: this.types[this.typeSort],
            time_out_facility: this.time_out_facility,
          };
          if (this.isAll) {
            if (
              this.filter.patient_id !== undefined &&
              this.filter.patient_id !== ""
            ) {
              payload.patient_id = this.filter.patient_id;
            }
            if (
              this.filter.name !== undefined &&
              this.filter.name !== ""
            ) {
              payload.name = this.filter.name;
            }

            if (this.ignoreIds.length > 0) {
              payload.ignore_ids = this.ignoreIds.toString();
            }
          } else {
            payload.ids = this.excelIds.toString();
          }
          const formattedDate = moment().format('YYYYMMDD');
          api.exportExcelHealKit(payload, `歩数_${this.userInfor.mobile}_${this.userInfor.patient_id}_${formattedDate}`)
          this.initExport();
        } catch (error) {
          console.log(error);
        }
      }
    },
    initExport() {
      this.isAll = false;
      this.ignoreIds = [];
      this.excelIds = [];
    },
  },
};
</script>


<style scoped>
* {
  font-family: "Noto Sans JP";
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #d3d3d3 !important;
  opacity: 1;
  /* Firefox */
}

.text-button {
  font-weight: 700 !important;
}

.text-table {
  font-weight: 400 !important;
  color: #404040;
}

.text-label-filter {
  font-weight: 700 !important;
  color: #404040 !important;
}

.text-link {
  color: #336aff;
}

.bg-icon {
  background: #8fc31f;
}

.bg-disabled {
  border: 1px solid #d3d3d3 !important;
  border-radius: 4px;
  background: #ffffff !important;
  color: #d3d3d3 !important;
}

/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

::v-deep .position-relative {
  position: unset;
}

::v-deep .b-table-sticky-header {
  max-height: 48vh;
  overflow: auto !important;
}

::v-deep td.tilte-column {
  color: #404040 !important;
  font-weight: 400 !important;
  font-size: 14px;
}

::v-deep table {
  border-top: 0 !important;
}

a.disabled {
  pointer-events: none;
  cursor: default;
}
</style>
